import React, { useContext, useEffect } from 'react'
import { useAlert } from '../../context/AlertContext'
import { AlertCloseIcon, AlertErrorIcon, AlertInfoIcon, AlertSuccessIcon } from '../iconSet/IconSet'

const AlertContainerComp = () => {

    const { alert, removeAlert} = useAlert()

    return (
        <div className={`alert-wrapper`}>
            {alert.map((item) => (
                <div key={item.id} className={`alert`} style={{
                    backgroundColor: item.type === 'ERROR' ? 'var(--color-main-red)' : item.type === 'INFO' ? 'var(--color-main-blue)' : item.type === 'SUCCESS' ? 'var(--color-main-green)' : ''}}>
                    {item.type === 'ERROR' ? <AlertErrorIcon  width='2rem'/> : item.type === 'INFO' ? <AlertInfoIcon width='2rem'/> : item.type === 'SUCCESS' ? <AlertSuccessIcon  width='2rem'/> : null}
                    <span>{item.message}</span>
                    <div onClick={() => removeAlert(item.id)} style={{cursor: 'pointer'}}>
                        <AlertCloseIcon className='alert-close-icon' width='1rem'/>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default AlertContainerComp